import { ComponentProps } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';

export type Breakdown =
  | AveragePlayerScore.LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE
  | AveragePlayerScore.LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE;
const breakdownScoreLabel = {
  [AveragePlayerScore.LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE]: 'AA',
  [AveragePlayerScore.LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE]: 'D',
};

const tooltipMessages: Record<Breakdown, MessageDescriptor> = {
  [AveragePlayerScore.LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE]:
    fantasy.allAroundScore,
  [AveragePlayerScore.LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE]:
    fantasy.decisiveScore,
};

type Props = {
  mode: Breakdown;
  color?: ComponentProps<typeof LabelS>['color'];
};

export const BreakdownScoreLabel = ({ mode, color }: Props) => {
  return (
    <Tooltip title={<FormattedMessage {...tooltipMessages[mode]} />}>
      <LabelS color={color}>{breakdownScoreLabel[mode]}</LabelS>
    </Tooltip>
  );
};
